import styled, { css } from "styled-components";

export const DivCoupon = styled.span`
  & {
    .akn-copy-icon-container {
      color: var(--live-button-color);
      font-weight: bold;
      margin-left: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 0.5ch;
    }
    .akn-coupon-without-discount {
      font-size: 0.825rem;
      white-space: nowrap;
      display: flex;
    }
    .akn-coupon-text {
      color: white;
      background: var(--live-button-color);
      display: inline-flex;
      padding: 0 5px;
    }
    .coupon-with-discount {
      display: flex;
      align-items: center;
      gap: 5px;
      &__text {
        color: #333333;
        font-weight: 600;
      }
    }
  }
`;
